<div class="sidenav-area">
  <mat-toolbar color="secondary" class="mb-5">
    <mat-toolbar-row>
      <button class="bigIconButton" mat-icon-button (click)="snav.toggle()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="white"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>
      </button>
      <span class="ml-3 text-white">Admin</span>
<!--      <a class="ml-2 text-white" [routerLink]="'currency-management'">Currency management</a>-->
<!--      <a class="ml-4 text-white" [routerLink]="'user-management'">User management</a>-->
      <span class="fill-space"></span>

      <button mat-icon-button id="logout-button" (click)="logout()">
        <i class="fa fa-2x fa-sign-out text-white" aria-hidden="true"></i>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav class="mat-elevation-z8" #snav [mode]="'side'" [fixedInViewport]="true" [fixedTopGap]="64">
      <mat-nav-list class="menuItems">
        <a mat-list-item [routerLink]="'currency-management'"><img class="mr-2" src="assets/images/payments_black_24dp.svg">Currency management</a>
        <a mat-list-item [routerLink]="'user-management'"><img class="mr-2" src="assets/images/people_black_24dp.svg">User management</a>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="sidenav-content container-fluid text-center">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
